import type { FC } from 'react';
import { PapiProductV3 } from '@wix/da-papi-types';
import { useTranslation } from 'react-i18next';
import { formatDollars } from '@wix/da-shared-react/pkg/utils/formatting';
import SaleLabel from '../../../../../Sales/SaleLabel';

import s from './PackageSavingsLabel.scss';

interface Props {
  corePackageProduct: PapiProductV3;
  anyPackageHasDiscount: boolean;
  showDiscountedPrice: boolean;
}

const PackageSavingsLabel: FC<Props> = ({
  corePackageProduct,
  anyPackageHasDiscount,
  showDiscountedPrice,
}) => {
  const { t } = useTranslation();
  const { discount, corePackage } = corePackageProduct;
  const { interval } = corePackage || {};

  if (!anyPackageHasDiscount && interval === 'year') {
    return (
      <SaleLabel className={s['sale-label']}>
        {t('packagePicker.billingCycle.new.bulkSavings', {
          amount: formatDollars(corePackage?.bulkPriceSaving),
        })}
      </SaleLabel>
    );
  }
  if (showDiscountedPrice) {
    return (
      <SaleLabel className={s['sale-label']}>
        {t('packagePicker.coreOffer.new.saleBadge', {
          discountPercent: discount?.amount.percent,
        })}
      </SaleLabel>
    );
  }
  return null;
};
PackageSavingsLabel.displayName = 'PackageSavingsLabel';

export default PackageSavingsLabel;
